import * as React from "react";

;
export const ChevronUp = (props: React.SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}><path fill="#100722" d="m12 8.06-8.47 8.47-1.06-1.06L12 5.94l9.53 9.53-1.06 1.06L12 8.06Z" /></svg>;